import apiClient from '@/Services/Clients/apiClient';
import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
import { SelfResponseSummaryDto, SelfResponseSummary } from '@/Models/selfResponseSummary';
import { FilteredRequestSummaryRequestDto } from '@/Models/filteredRequestSummaryRequestDto';
import { FilteredRequestSummaryResponseDto } from '@/Models/filteredRequestSummaryResponseDto';
import { FilterItemDto } from '@/VueComponents/Filter/Dtos/filterItemDto';
import { InitialFilterCriteriaDto } from '@/VueComponents/Filter/Dtos/initialFilterCriteriaDto';
import PageResultModel from '@/Models/pageResultModel';

const SELF_RESPONSE_SUMMARY_BASE_URL = 'api/selfresponsesummary';

export default class SelfResponseSummaryService {


  public static getInitialFilter = (): Promise<InitialFilterCriteriaDto> => {
    const contextData = useContextDataStore();
    return apiClient.get(`${SELF_RESPONSE_SUMMARY_BASE_URL}/${contextData.userData.business.businessId}/initialFilterCriteria`);
  };

  public static getSelfResponseSummaries = (
    filterCriteria: FilterItemDto[],
    sortField: string,
    sortOrder: string,
    page: number,
    pageSize: number): Promise<PageResultModel> => {

    const contextData = useContextDataStore();
    const uri = `${SELF_RESPONSE_SUMMARY_BASE_URL}/${contextData.userData.business.businessId}`;

    const filteredRequest = new FilteredRequestSummaryRequestDto(
      contextData.userData.business.businessId,
      filterCriteria,
      sortField,
      sortOrder,
      page,
      pageSize);

    return apiClient.post(uri, filteredRequest)
      .then((serverPageResult: FilteredRequestSummaryResponseDto) => {

        const responseModels = serverPageResult.results.map((responseSummary: SelfResponseSummaryDto) => {
          return new SelfResponseSummary(responseSummary);
        });

        const pageResult = new PageResultModel(serverPageResult, responseModels);

        return pageResult;
      });
  };
}